export default {
  'processGroup.title': 'Manage Process Groups',
  'processGroup.parentProcessGroup': 'Parent Processes Group',
};
